module.exports = __webpack_public_path__ + "static/img/5.aef4759.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/5.png
// module id = Z8wW
// module chunks = 0